import { css } from 'emotion';

export const hubspotTogglePosition = (isOpen: boolean, width?: number | string) => css`
  transition: right 0.2s;
  right: ${isOpen ? (typeof width === 'string' ? width : `${width}px`) : '0px'} !important;
`;

export default hubspotTogglePosition;
